import { useEffect } from 'react';
import { useToast, setToastApi } from '../../contexts/ToastContext';

/** Wires imperative toast API for non-hook modules */
export default function ToastBridge() {
  const api = useToast();
  useEffect(() => {
    setToastApi(api);
    return () => setToastApi(null);
  }, [api]);
  return null;
}
